import React from "react";
import { Box, Typography, Chip } from "@mui/material";

interface TabletNoticeProps {
  page: string;
}

const TabletNotice: React.FC<TabletNoticeProps> = ({ page }) => (
  <Box
    sx={{
      mb: 1.5,
      p: 1.25,
      borderRadius: 1,
      backgroundColor: "#eaf5ee",
      border: "1px solid #c2dfcb",
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    <Chip
      label="Tablet"
      color="success"
      size="small"
      sx={{ fontWeight: 600, fontSize: "0.72rem", height: 22 }}
    />
    <Typography variant="caption" sx={{ color: "#1f5230" }}>
      {page} — adapted for tablet screens.
    </Typography>
  </Box>
);

export default TabletNotice;
